import React from 'react'
import { CFSelect, CFView, DefaultScreen, MobileScreen } from 'components'
import { isEmpty } from 'lodash'
import { moment, formatWeeklyHours } from 'cf-utils'
import { dispatch } from 'store'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView h3 futura bold color="#B98F60" p="15px" column center>
          BUSINESS HOURS
        </CFView>
        <CFView maxWidth="250px">
          <CFSelect selector={dispatch.restaurant.getHours}>
            {hours =>
              [1, 2, 3, 4, 5, 6, 0].map(day => (
                <CFView key={day} column>
                  <CFView row w="100%" mb="10px">
                    <CFView w="80px">
                      <CFView h5 white bold>{`${moment()
                        .weekday(day)
                        .format('ddd')}`}</CFView>
                    </CFView>
                    <CFView h5 white bold w="100%" row justifyEnd textRight>
                      {isEmpty(hours) ? '' : formatWeeklyHours(hours[day], dispatch.restaurant.getSelectedLocation()?.timeZone, ' ')}
                    </CFView>
                  </CFView>
                </CFView>
              ))
            }
          </CFSelect>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView h3 futura bold color="#B98F60" pb="20px">
          BUSINESS HOURS
        </CFView>
        <CFView minWidth="300px">
          <CFSelect selector={dispatch.restaurant.getHours}>
            {hours =>
              [1, 2, 3, 4, 5, 6, 0].map(day => (
                <CFView key={day}>
                  <CFView row w="100%" mb="10px">
                    <CFView w="80px">
                      <CFView h5 white bold>{`${moment()
                        .weekday(day)
                        .format('ddd')}`}</CFView>
                    </CFView>
                    <CFView h5 white bold>
                      {isEmpty(hours) ? '' : formatWeeklyHours(hours[day], dispatch.restaurant.getSelectedLocation()?.timeZone)}
                    </CFView>
                  </CFView>
                </CFView>
              ))
            }
          </CFSelect>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
